import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateAgentForm from '../components/agent/CreateAgentForm';

const CreateAgentPage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/my-agents');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-8">Create New Agent</h1>
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 shadow-xl">
           <CreateAgentForm onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  );
};

export default CreateAgentPage;